// import { graphql, useStaticQuery } from "gatsby";

export default function useLocaleMode() {
  const locale = process.env.LOCALE

  const country = {
    codigoDeDosLetras: process.env.LOCALE.replace("es-", ""),
    codigoDelPais: process.env.COUNTRY_CODE,
    dominio: process.env.SITE_URL,
    lenguaje: "es",
    prefijoTelefonico: process.env.COUNTRY_PHONE_PREFIX,
    titulo: process.env.COUNTRY_NAME,
  }

  return { locale, country }
}
